module.exports = __webpack_public_path__ + "img/success.92adc67c.svg";